import { Component, OnInit, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Role } from "@app/core/auth/identity/user.reducer";

@Component({
  selector: "ddd-fm-dashboard-first-visit",
  templateUrl: "./fm-dashboard-first-visit.component.html",
  standalone: true,
  imports: []
})
export class FMDashboardFirstVisitComponent implements OnInit {
  dialogRef = inject<MatDialogRef<FMDashboardFirstVisitComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  public dialog: any;
  public roles = {
    keyContact: false,
    approver: false,
    fmTemplateOwner: false
  };

  ngOnInit() {
    if (this.data.userRoles) {
      this.roles = {
        keyContact: this.roleIncludes(this.data.userRoles, Role.KeyContact),
        approver: this.roleIncludes(this.data.userRoles, Role.Approver),
        fmTemplateOwner: this.roleIncludes(this.data.userRoles, Role.FMTemplateOwner)
      };
    }
  }

  public roleIncludes(array: Array<Role>, value: number): boolean {
    return array.indexOf(value) > -1;
  }
}
